var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNih(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    xmlSpace: "preserve",
    width: "36px",
    height: "36px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .color1 {\r\n    fill: #FFF;\r\n    }\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "color1",
    d: "M49.4,14.2H5.8c-2.2,0-3.9,1.8-3.9,4v35.6c0,2.2,1.8,4,3.9,4h43.6L61.3,36L49.4,14.2z M24,45.8h-3.5l-8.7-14.4h-0.1v14.4   H8.5V26.3h3.5l8.7,14.4h0.1V26.3H24V45.8z M30.7,45.8h-3.3V26.3h3.3V45.8z M46.1,45.8V37h-8.7v8.8H34V26.3h3.4v7.8h8.7v-7.8h3.3   v19.5H46.1z M59.7,16.8c-0.8-1.4-2.8-2.6-4.4-2.6h-3L64.2,36L52.3,57.8h3c1.6,0,3.6-1.2,4.4-2.6L70.1,36L59.7,16.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNih);
export default __webpack_public_path__ + "static/media/nih.1a7818f938c08c054c916629c1c3f278.svg";
export { ForwardRef as ReactComponent };